import { InstitutionQueryOptions, ProjectPopulation, ProjectQueryOptions } from '@dh/types';
import { FilterOptions } from '@dh/utils';

type Pagination = {
    start: number;
    limit: number;
};

/* when users are searching, we are triggering a certain set of filters
on search results pages, we can further filter the results with "additionalFilters"
we are combining the original search (which uses an $or operator) with additional filters through an $and operator */

const createProjectSearchOptions = (
    searchTerm: string,
    pagination?: Pagination,
    additionalFilters?: FilterOptions
): ProjectQueryOptions => {
    const searchTermQuery = {
        $or: [
            { 0: { title: { $containsi: searchTerm } } },
            { 1: { topics: { title_de: { $containsi: searchTerm } } } },
            { 2: { client: { name: { $containsi: searchTerm } } } },
            { 3: { partnerCompany: { name: { $containsi: searchTerm } } } }
        ]
    };
    if (additionalFilters) {
        return {
            filters: {
                $and: [
                    {
                        0: searchTermQuery
                    },
                    {
                        1: {
                            ...additionalFilters
                        }
                    }
                ]
            },
            sort: ['updatedAt:desc'],
            populateVariant: ProjectPopulation.Basic
        };
    }
    return {
        filters: searchTermQuery,
        pagination,
        sort: ['updatedAt:desc'],
        populateVariant: ProjectPopulation.Basic
    };
};

const createCompanySearchTermQueryOptions = (
    searchTerm: string,
    pagination?: Pagination,
    additionalFilters?: FilterOptions
): InstitutionQueryOptions => {
    let queryOptions = {
        filters: {
            type: 'company'
        },
        pagination,
        sort: ['updatedAt:desc'],
        populate: {
            logo: {
                populate: true
            },
            media: {
                populate: true
            },
            admins: {
                populate: true
            },
            projects: {
                populate: true
            },
            topicsKnowledge: {
                populate: true
            }
        }
    };

    const searchTermQuery = (searchTerm: string) => ({
        $or: [
            { 0: { name: { $containsi: searchTerm } } },
            { 1: { slogan: { $containsi: searchTerm } } },
            { 2: { admins: { $containsi: searchTerm } } },
            { 3: { projects: { title: { $containsi: searchTerm } } } },
            { 4: { topicsKnowledge: { topic: { title_de: { $containsi: searchTerm } } } } }
        ]
    });

    if (additionalFilters) {
        return {
            filters: {
                ...queryOptions.filters,
                $and: [
                    {
                        0: searchTermQuery
                    },
                    {
                        1: additionalFilters
                    }
                ]
            }
        };
    } else
        return {
            filters: {
                ...queryOptions.filters,
                ...searchTermQuery
            }
        };
};

export { createProjectSearchOptions, createCompanySearchTermQueryOptions };
